/* 🤖 this file was generated by svg-to-ts */
export const iconFei: {
  name: 'fei';
  data: string;
} = {
  name: 'fei',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-2.94 8.44 2.17-3.2a1 1 0 0 1 1.66.01l2.09 3.2a1 1 0 0 1-.84 1.55h-4.26c-.8 0-1.28-.9-.83-1.56zm11.69 14.69H7.24c-1.19 0-1.9-1.31-1.26-2.31l4.98-7.77c.37-.57 1-.92 1.68-.92h6.71c.68 0 1.32.35 1.68.92l4.98 7.77c.64 1-.08 2.31-1.26 2.31"/></svg>`,
};
